export default "__VITE_ASSET__CcE3$LjY__"